(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
	super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.headerWrapper = document.querySelector('.header-wrapper');
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
		this.headerBounds = {};
		this.currentScrollTop = 0;
		this.preventReveal = false;
		this.predictiveSearch = this.querySelector('predictive-search');

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;
		//this.throttledScrollHandler = throttle(this.onScrollHandler, 300);

		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
		this.headerBounds = entries[0].intersectionRect;
		observer.disconnect();
		});

		if (this.header) {
			observer.observe(this.header);
		}
	}

	onScroll() {
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
		this.header.classList.add('shopify-section-header-sticky','shopify-section-header-always-sticky');
		this.header.style.transform = 'translateY(-100%)';
	};

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 2) {
		this.header.classList.remove('color-background-2');
		this.header.style.transition = 'background var(--duration-short)';
		this.header.style.transform = 'translateY(0)';
	};

	if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
		this.header.classList.remove('shopify-section-header-sticky');
		this.header.style.transform = 'translateY(0)';
		this.header.style.transition = 'background var(--duration-short)';
		if (this.header.classList.contains('color-background-1')) {
		this.header.classList.add('color-background-2');
		};
	};

	if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (this.preventHide) return;
		requestAnimationFrame(this.hide.bind(this));
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (!this.preventReveal) {
		requestAnimationFrame(this.reveal.bind(this));
		} else {
			window.clearTimeout(this.isScrolling);

			this.isScrolling = setTimeout(() => {
			this.preventReveal = false;
			}, 66);

			requestAnimationFrame(this.hide.bind(this));
		}
		} else if (scrollTop <= this.headerBounds.top) {
		requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		if (this.headerIsAlwaysSticky) return;		
		if (document.querySelector(".overflow-hidden-tablet")) return;
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		if (this.headerIsAlwaysSticky) return;
		if (document.querySelector('.entering-section')) {
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-hidden');
		}
		else{
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-hidden','color-background-2');
		}
	}

	reset() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
		if (this.header.classList.contains('color-background-1')) {
			this.header.classList.add('color-background-2');
		};
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		if (this.disclosures) {
			this.disclosures.forEach(disclosure => {
				disclosure.close(); 
			});
		}
		this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
			if (this.disclosureLists) {
				this.disclosureLists.forEach(disclosureList => {
					disclosureList.setAttribute('hidden', true); 
				});
			}
		}
	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();

      this.isProductPage = true;
    }

    hide() {
      super.hide(this.isProductPage);
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      if (activeMedia) {
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();
      }
      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  // === MOBILE FULLSCREEN SLIDER (gallery_type: two_column_mobile_slider) ===
  (function () {
    const SEL = '.product__mobile-slider';
    const MQ = window.matchMedia('(max-width: 749px)');

    const initOne = (el) => {
      if (el.swiper) return true;
      if (typeof Swiper === 'undefined') return false;
      if (!el.offsetParent || el.offsetWidth === 0) return false;

      const paginationEl = el.querySelector('.product__mobile-slider-pagination');
      new Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 0,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        resizeObserver: true,
        threshold: 3,
        pagination: paginationEl
          ? {
              el: paginationEl,
              type: 'progressbar',
            }
          : false,
      });
      el.classList.remove('mobile-slider--fallback');
      if (!el.__cwsScrollGuard) {
        el.__cwsScrollGuard = true;
        el.addEventListener('scroll', () => {
          if (el.classList.contains('mobile-slider--fallback')) return;
          if (el.scrollLeft !== 0) el.scrollLeft = 0;
          if (el.scrollTop !== 0) el.scrollTop = 0;
        });
      }
      return true;
    };

    const initAll = () => {
      if (!MQ.matches) return true;
      const nodes = document.querySelectorAll(SEL);
      if (!nodes.length) return true;
      let ok = true;
      nodes.forEach((el) => {
        if (!initOne(el)) ok = false;
      });
      return ok;
    };

    const enableFallback = () => {
      document.querySelectorAll(SEL).forEach((el) => {
        if (!el.swiper) el.classList.add('mobile-slider--fallback');
      });
    };

    const boot = () => {
      if (initAll()) return;
      let tries = 0;
      const iv = setInterval(() => {
        tries += 1;
        if (initAll()) {
          clearInterval(iv);
          return;
        }
        if (tries > 50) {
          clearInterval(iv);
          enableFallback();
        }
      }, 200);
    };

    const refresh = () => {
      document.querySelectorAll(SEL).forEach((el) => {
        if (el.swiper) el.swiper.update();
      });
      boot();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    window.addEventListener('load', refresh);
    document.addEventListener('shopify:section:load', boot);
    document.addEventListener('shopify:section:select', refresh);

    if (MQ.addEventListener) {
      MQ.addEventListener('change', refresh);
    } else if (MQ.addListener) {
      MQ.addListener(refresh);
    }
  })();

  // === AUTOPLAY + LOOP VIDEO (GALLERY + MODAL) ===
  (function () {
    const YT_PARAMS = { autoplay: '1', mute: '1', playsinline: '1', enablejsapi: '1', loop: '1' };
    const VM_PARAMS = { autoplay: '1', muted: '1', loop: '1' };

    const addQueryParams = (url, params) => {
      try {
        const u = new URL(url, window.location.origin);
        Object.entries(params).forEach(([k, v]) => u.searchParams.set(k, v));
        return u.toString();
      } catch {
        const hasQ = url.includes('?');
        const qs = Object.entries(params)
          .map(([k, v]) => `${k}=${v}`)
          .join('&');
        return url + (hasQ ? '&' : '?') + qs;
      }
    };

    const ensureIframeAutoplay = (iframe) => {
      if (!iframe) return;
      const allow = iframe.getAttribute('allow') || '';
      if (!/autoplay/i.test(allow)) {
        iframe.setAttribute(
          'allow',
          (allow ? allow + '; ' : '') + 'autoplay; fullscreen; encrypted-media; picture-in-picture'
        );
      }
      const src = iframe.getAttribute('src') || '';
      const low = src.toLowerCase();
      if (low.includes('youtube.com') || low.includes('youtube-nocookie.com')) {
        if (!(low.includes('loop=1') && low.includes('playlist='))) {
          const videoId = (src.match(/embed\/([^?]+)/) || [])[1] || '';
          iframe.src = addQueryParams(src, { ...YT_PARAMS, playlist: videoId });
        }
      } else if (low.includes('vimeo.com')) {
        if (!low.includes('loop=1')) {
          iframe.src = addQueryParams(src, VM_PARAMS);
        }
      }
    };

    const playNativeVideo = (v) => {
      if (!v) return;
      v.muted = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      v.setAttribute('webkit-playsinline', '');
      v.loop = true;
      if (v.closest('.product__mobile-slider')) {
        v.controls = false;
        v.removeAttribute('controls');
        v.style.pointerEvents = 'none';
      }
      if (!v.__cwsLoopBound) {
        v.__cwsLoopBound = true;
        v.addEventListener('ended', () => {
          v.currentTime = 0;
          v.play().catch(() => {});
        });
      }
      v.play().catch(() => {});
    };

    const clickPosterSafely = (btn) => {
      if (!btn) return;
      const saved = [];
      let node = btn.parentElement;
      while (node && node !== document.body) {
        saved.push([node, node.scrollLeft, node.scrollTop]);
        node = node.parentElement;
      }
      const x = window.scrollX,
        y = window.scrollY;
      try {
        btn.click();
      } catch (e) {}
      saved.forEach(([n, sl, st]) => {
        n.scrollLeft = sl;
        n.scrollTop = st;
      });
      window.scrollTo(x, y);
    };

    const loadDeferred = (root) => {
      const dm = root.querySelector('deferred-media');
      if (!dm) return false;
      if (dm.__cwsLoaded) return true;
      dm.__cwsLoaded = true;
      if (typeof dm.loadContent === 'function') dm.loadContent();
      else clickPosterSafely(dm.querySelector('.deferred-media__poster'));
      return true;
    };

    const hasMedia = (root) => !!root && !!root.querySelector('video, iframe, deferred-media');

    const activateAutoplayIn = (root) => {
      if (!hasMedia(root)) return;
      loadDeferred(root);
      setTimeout(() => {
        root.querySelectorAll('video').forEach(playNativeVideo);
        root.querySelectorAll('iframe').forEach(ensureIframeAutoplay);
      }, 60);
    };

    const handleSwiper = (swiper) => {
      const onChange = () => {
        swiper.slides.forEach((slide) => {
          if (!slide.classList.contains('swiper-slide-active')) {
            slide.querySelectorAll('video').forEach((v) => {
              try {
                v.pause();
              } catch (e) {}
            });
          }
        });
        activateAutoplayIn(swiper.slides[swiper.activeIndex]);
      };
      setTimeout(onChange, 120);
      swiper.on('slideChange', onChange);
      swiper.on('slideChangeTransitionEnd', onChange);
    };

    const initGallery = () => {
      document.querySelectorAll('.js-media-list.swiper, .product__mobile-slider').forEach((el) => {
        const boot = () => {
          const sw = el.swiper;
          if (!sw) return false;
          if (!sw.__cwsAutoplayBound) {
            sw.__cwsAutoplayBound = true;
            handleSwiper(sw);
          }
          const active = el.querySelector('.swiper-slide-active');
          if (active) activateAutoplayIn(active);
          return true;
        };
        if (!boot()) {
          let tries = 0;
          const iv = setInterval(() => {
            if (boot() || ++tries > 40) clearInterval(iv);
          }, 150);
        }
      });
    };

    const initModal = () => {
      document.querySelectorAll('.product-media-modal').forEach((m) => {
        m.addEventListener('transitionend', () => {
          const active = m.querySelector('.product-media-modal__item.active');
          if (active) activateAutoplayIn(active);
        });
      });
    };

    const watchDynamicMedia = () => {
      const mo = new MutationObserver((muts) => {
        muts.forEach((m) => {
          m.addedNodes &&
            m.addedNodes.forEach((node) => {
              if (!(node instanceof HTMLElement)) return;
              const slide = node.closest ? node.closest('.swiper-slide') : null;
              if (slide && !slide.classList.contains('swiper-slide-active')) return;
              if (node.matches('video')) playNativeVideo(node);
              else if (node.matches('iframe')) ensureIframeAutoplay(node);
              else if (node.querySelector) {
                node.querySelectorAll('video').forEach(playNativeVideo);
                node.querySelectorAll('iframe').forEach(ensureIframeAutoplay);
              }
            });
        });
      });
      mo.observe(document.documentElement, { childList: true, subtree: true });
    };

    document.addEventListener('DOMContentLoaded', () => {
      initGallery();
      initModal();
      watchDynamicMedia();
    });
    window.addEventListener('load', initGallery);
    document.addEventListener('shopify:section:load', initGallery);
  })();

  } catch(e) { console.error(e); }
})();
})();
